import * as _ from "lodash";
import { ProductGroupBO } from "./ProductGroupBO";
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_FinishedProductRelationshipRow,
    WB_PeriodRow,
    WB_PlanManagementPeriodRow,
    WB_PlanManagementRow,
    WB_PlanManagementUserGroupRow,
    WB_PlanManagementUserRow,
    WB_ProductGroupRow,
    WB_TransactionItemRow,
    WB_UserGroupRow,
    WB_UserRow,
} from "../PA.Core/PAdbSchemaRows";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { PlanManagementBO } from "./PlanManagementBO";

export class PlanManagementBOValidations {
    static ValidateEmptyFields(aBO: PlanManagementBO): Promise<void> {
        return new Promise((resolve, error) => {
            if (
                _.isEmpty(aBO.WB_PlanManagement.cif.PLNMGMT_ID) ||
                _.isUndefined(aBO.WB_PlanManagement.cif.PLNMGMT_ID) ||
                _.isNull(aBO.WB_PlanManagement.cif.PLNMGMT_ID)
            ) {
                aBO.ValidateMessageProvider.addMessage({
                    code: "EmptyId",
                    type: MessageType.Error,
                    title: "Plan Management ID cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("EmptyId");
            }

            if (_.isEmpty(aBO.WB_PlanManagement.cif.PLNMGMT_NAME)) {
                aBO.ValidateMessageProvider.addMessage({
                    code: "EmptyName",
                    type: MessageType.Error,
                    title: "Plan Management Name cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("EmptyName");
            }

            if (aBO.WB_PlanManagement.cif.WB_CUST_ID_PLANNING == 0) {
                aBO.ValidateMessageProvider.addMessage({
                    code: "customerid",
                    type: MessageType.Error,
                    title: "Customer cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("customerid");
            }

            if (aBO.WB_PlanManagement.cif.WB_MDSET_ID == 0) {
                aBO.ValidateMessageProvider.addMessage({
                    code: "mdsetid",
                    type: MessageType.Error,
                    title: "Master Dataset cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("mdsetid");
            }

            if (aBO.WB_PlanManagement.cif.WB_SALESAREA_ID == 0) {
                aBO.ValidateMessageProvider.addMessage({
                    code: "salesareaid",
                    type: MessageType.Error,
                    title: "Sales area cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("salesareaid");
            }

            //     let bPlantype = false
            //
            // _.forEach(_.filter(aBO.WB_PlanManagement.WB_PlanManagementPeriodRows, (x: WB_PlanManagementPeriodRow) => x.isActive) , (aRow)=> {
            //
            //     if(_.isEmpty(aRow.cif.WB_PLANM_ID) || _.isNull(aRow.cif.WB_PLANM_ID) || _.isUndefined(aRow.cif.WB_PLANM_ID)){
            //         bPlantype = true
            //     }
            //
            // })
            //
            // if(bPlantype){
            //     // Log Message
            //     aBO.ValidateMessageProvider.addMessage(
            //         {
            //             code: 'plantype',
            //             type: MessageType.Error,
            //             title: "Plan Type cannot be empty",
            //             description: "",
            //             subtitle: "",
            //             count: 0
            //         })
            //
            // } else {
            //     aBO.ValidateMessageProvider.removeMessage('plantype')
            //
            // }

            let bDateOrderingIncorrect = false;
            let bStartDate = false;
            let bEndDate = false;

            _.forEach(
                _.filter(
                    aBO.WB_PlanManagement.WB_PlanManagementUserGroupRows,
                    (x: WB_PlanManagementUserGroupRow) => x.isActive,
                ),
                (aRow) => {
                    if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                        bStartDate = true;
                    }

                    if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                        bEndDate = true;
                    }
                    if (_.isDate(aRow.cif.EFFECTIVE_START_DT) && _.isDate(aRow.cif.EFFECTIVE_END_DT)) {
                        if (aRow.cif.EFFECTIVE_END_DT < aRow.cif.EFFECTIVE_START_DT) {
                            bDateOrderingIncorrect = true;
                        }
                    }
                },
            );

            if (bEndDate) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage({
                    code: "enddate",
                    type: MessageType.Error,
                    title: "End Date cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("enddate");
            }
            if (bStartDate) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage({
                    code: "startdate",
                    type: MessageType.Error,
                    title: "Start Date cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("startdate");
            }

            if (bDateOrderingIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage({
                    code: "usergroupdates",
                    type: MessageType.Error,
                    title: "Effective start date must be before the effective end date",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("usergroupdates");
            }

            let buserstartdate = false;
            let buserenddate = false;
            let bUserDateOrderingIncorrect = false;

            _.forEach(
                _.filter(aBO.WB_PlanManagement.WB_PlanManagementUserRows, (x: WB_PlanManagementUserRow) => x.isActive),
                (aRow) => {
                    if (_.isEmpty(aRow.cif.EFFECTIVE_START_DT)) {
                        buserstartdate = true;
                    }

                    if (_.isEmpty(aRow.cif.EFFECTIVE_END_DT)) {
                        buserenddate = true;
                    }

                    if (_.isDate(aRow.cif.EFFECTIVE_START_DT) && _.isDate(aRow.cif.EFFECTIVE_END_DT)) {
                        if (aRow.cif.EFFECTIVE_END_DT < aRow.cif.EFFECTIVE_START_DT) {
                            bUserDateOrderingIncorrect = true;
                        }
                    }
                },
            );

            if (buserstartdate) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage({
                    code: "userstartdate",
                    type: MessageType.Error,
                    title: "Start Date cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("userstartdate");
            }

            if (buserenddate) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage({
                    code: "userenddate",
                    type: MessageType.Error,
                    title: "End Date cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("userenddate");
            }

            if (bUserDateOrderingIncorrect) {
                // Log Message
                aBO.ValidateMessageProvider.addMessage({
                    code: "userorderdates",
                    type: MessageType.Error,
                    title: "Effective start date must be before the effective end date",
                    description: "",
                    subtitle: "",
                    count: 0,
                });
            } else {
                aBO.ValidateMessageProvider.removeMessage("userorderdates");
            }
            resolve();
        });
    }
}
